import { render, staticRenderFns } from "./RelationshipsTab.vue?vue&type=template&id=44954684&scoped=true"
import script from "./RelationshipsTab.vue?vue&type=script&lang=js"
export * from "./RelationshipsTab.vue?vue&type=script&lang=js"
import style0 from "./RelationshipsTab.vue?vue&type=style&index=0&id=44954684&prod&lang=scss&scoped=true"
import style1 from "./RelationshipsTab.vue?vue&type=style&index=1&id=44954684&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44954684",
  null
  
)

export default component.exports